export const REDUCER_NAME = "teamPlayers";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_TEAMPLAYERS = `${REDUCER_NAME}/SET_TEAMPLAYERS`;
export const RESET_TEAMPLAYERS = `${REDUCER_NAME}/RESET_TEAMPLAYERS`;
